
import {
    ADD_PROSPECT_VIOLATION,
    ADD_PROSPECT_VIOLATION_SUCCESS,
    ADD_PROSPECT_VIOLATION_ERROR,
    UPDATE_PROSPECT_VIOLATION,
    UPDATE_PROSPECT_VIOLATION_SUCCESS,
    UPDATE_PROSPECT_VIOLATION_ERROR,
    DELETE_PROSPECT_VIOLATION,
    DELETE_PROSPECT_VIOLATION_SUCCESS,
    DELETE_PROSPECT_VIOLATION_ERROR,
} from "./actionTypes";

// addLeadViolation
export const addProspectViolation = payload => {
    return {
        type: ADD_PROSPECT_VIOLATION,
        payload: payload,
    }
}

// addLeadViolationSuccess
export const addProspectViolationSuccess = prospect => {
    return {
        type: ADD_PROSPECT_VIOLATION_SUCCESS,
        payload: prospect,
    }
}

// addLeadViolationError
export const addProspectViolationError = error => {
    return {
        type: ADD_PROSPECT_VIOLATION_ERROR,
        payload: error,
    }
}

// updateLeadViolation
export const updateProspectViolation = payload => {
    return {
        type: UPDATE_PROSPECT_VIOLATION,
        payload: payload,
    }
}

// updateLeadViolationSuccess
export const updateProspectViolationSuccess = prospect => {
    return {
        type: UPDATE_PROSPECT_VIOLATION_SUCCESS,
        payload: prospect,
    }
}

// updateLeadViolationError
export const updateProspectViolationError = error => {
    return {
        type: UPDATE_PROSPECT_VIOLATION_ERROR,
        payload: error,
    }
}

// deleteLeadViolation
export const deleteProspectViolation = payload => {
    return {
        type: DELETE_PROSPECT_VIOLATION,
        payload: payload,
    }
}

// deleteLeadViolationSuccess
export const deleteProspectViolationSuccess = prospect => {
    return {
        type: DELETE_PROSPECT_VIOLATION_SUCCESS,
        payload: prospect,
    }
}

// deleteLeadViolationError
export const deleteProspectViolationError = error => {
    return {
        type: DELETE_PROSPECT_VIOLATION_ERROR,
        payload: error,
    }
}